import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@webdatarocks/webdatarocks/webdatarocks.min.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // disable strict mode due to compatibility with react-beautiful-dnd
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
